// extracted by mini-css-extract-plugin
export default {"desc":"News_desc__Vtfvb","date":"News_date__roiKK","date2":"News_date2__p1DBk","aboutBg":"News_aboutBg__5YiFu"};